import { render, staticRenderFns } from "./SeccionReglamento.vue?vue&type=template&id=5502e6bf&"
import script from "./SeccionReglamento.vue?vue&type=script&lang=js&"
export * from "./SeccionReglamento.vue?vue&type=script&lang=js&"
import style0 from "./SeccionReglamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports